export const LEVER_POSTINGS_ENDPOINT = 'https://api.lever.co/v0/postings/delphix?mode=json';
